export default "__VITE_ASSET__855c26d5__"